// ** React Imports
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

// ** Custom Components
import Avatar from '@components/avatar'

// ** Utils

// ** Store & Actions
import { useDispatch, connect } from 'react-redux'

// ** Third Party Components
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'
import { User, Power } from 'react-feather'
import {logoutAction} from "@store/actions/auth";
import langConfig from "@configs/langConfig"

// ** Default Avatar Image

const UserDropdown = props => {
  // ** Store Vars
  const dispatch = useDispatch()

  const {t} = langConfig

  const [userData, setUserData] = useState({
       imageProfile : '',
       userData : {
           username : '',
           role_id : ''
       }
   })

  useEffect(_ => {
      const storeUserdata = JSON.parse(localStorage.getItem('user_data'));
      const imageProfile = `https://ui-avatars.com/api/?name=${storeUserdata.username || storeUserdata.firstname}&color=7F9CF5&background=EBF4FF`
      setUserData({...userData, imageProfile, userData: storeUserdata})
  }, [])

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
            <span className='user-name font-weight-bold'>{userData.userData.username}</span>
            <span className='user-status'>{userData.userData.role_slug === 'admin' ? 'Admin' : 'User'}</span>
        </div>
        <Avatar img={userData.imageProfile} imgHeight='40' imgWidth='40' status='online' />
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem tag={Link} to='/account-settings'>
          <User size={14} className='mr-75' />
          <span className='align-middle'>{t('Account settings')}</span>
        </DropdownItem>
        <DropdownItem tag={Link} to='#' onClick={() => {
            console.log('Logout event')
            dispatch(logoutAction())
        }
        }
        >
          <Power size={14} className='mr-75' />
          <span className='align-middle'>{t('Logout')}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

const mapStateToProps = state => {
    return {
        userInfoData : state.userInfo
    }
}

export default connect(mapStateToProps, null)(UserDropdown)
